class SubMenu extends HTMLElement {
    constructor() {
        super();
        this.dom = {}
        this.setUpDom();
        if (sessionStorage.getItem('clicked-noti')) {
            this.querySelector('.header__nav--btn-noti .header__nav--notif').classList.remove('active');
        }
    }
    setUpDom() {
        this.dom.items = this.getElementsByClassName('js-nav--btn');
        this.addEvent();
    };
    addEvent() {
        let item;
        const items = this.dom.items;
        for (item of items) {
            item.addEventListener('click', this.handle.bind(this, item));
        }
    };
    handle(item) {
        let itemParen = item.parentNode;
        let closeMb = itemParen.querySelector('.js--close');
        closeMb.addEventListener('click', () => {
            itemParen.classList.remove('active');
            document.body.style.overflow = "initial";
        })
        let checkClass = itemParen.classList.contains('active');
        if (checkClass == true) {
            itemParen.classList.remove('active');
            document.body.style.overflow = "initial";
            document.querySelector('.cart-drawer__overlay').classList.remove('active');
            document.querySelector("body").classList.remove('cart-drawer-open');

        } else {
            document.body.style.overflow = "hidden";
            this.removeClass();
            itemParen.classList.add('active');
            document.querySelector('.cart-drawer__overlay').classList.add('active');
            document.querySelector("body").classList.add('cart-drawer-open');

            if (itemParen.querySelector('.header__nav--btn-noti .header__nav--notif')) {
                sessionStorage.setItem('clicked-noti', 'true');
                itemParen.querySelector('.header__nav--btn-noti .header__nav--notif').classList.remove('active');
            }
        }
    }
    removeClass() {
        let item;
        for (item of this.dom.items) {
            item.parentNode.classList.remove('active');
        }
    }

}
customElements.define('sub-menu', SubMenu);

// CUSTOM SUBMENU DESKTOP

const navigationMenuLinksDesktop = document.querySelectorAll('header .header__nav--list .item');
navigationMenuLinksDesktop.forEach(link => {
    link.addEventListener('mouseover', () => {
        link.classList.add('open');
    })
    link.addEventListener('mouseleave', () => {
        link.classList.remove('open');
    })
})

// CUSTOM SUBMENU MOBILE

const navigationMenuLinksMobile = document.querySelectorAll('.menu-drawer .menu-drawer__main-links .menu-link-item');
navigationMenuLinksMobile.forEach(link => {
    link.addEventListener('click', () => {
        if (link.classList.contains('open')) {
            link.classList.remove('open');
        } else {
            link.classList.add('open');
        }
    })
})
